import dayjs from 'dayjs';

import { API_DATE_FORMAT } from './date';

const DEFAULT_PRODUCT_MAX_PAYMENT_DUE_YEARS = 3;

export const PRODUCTS_LIMIT = 200;
export const PRODUCT_PRICE_CURRENCY = '£';
export const PRODUCT_PRICE_CURRENCY_CODE = 'GBP';
export const PRODUCT_CUSTOM_PAYMENT_CODE = 'CST';
export const PRODUCT_MIN_PRICE = 0;
export const PRODUCT_MAX_PRICE = 999.99;
export const PRODUCT_MIN_QUANTITY = 0.1; // tonnes
export const PRODUCT_MAX_QUANTITY = 1000; // tonnes
export const PRODUCT_MAX_PAYMENT_DUE_YEARS =
  Number(process.env.REACT_APP_PRODUCT_MAX_PAYMENT_DUE_YEARS) ||
  DEFAULT_PRODUCT_MAX_PAYMENT_DUE_YEARS;
export const PRODUCT_MAX_PAYMENT_DUE_DATE = dayjs()
  .add(PRODUCT_MAX_PAYMENT_DUE_YEARS, 'years')
  .format(API_DATE_FORMAT); // date
export const OXBURY_CODE = process.env.REACT_APP_OXBURY_CODE || 'OX';
export const CROP_OXBURY_CODE = process.env.REACT_APP_CROP_OXBURY_CODE || 'OX';
export const DISPLAY_PRODUCT_SUBGROUP =
  process.env.REACT_APP_FEATURE_FLAGS_DISPLAY_PRODUCT_SUBGROUP === 'true';
export const SUBGROUP_AUTOCOMPLETE_LIMIT = 100;
export const DEFAULT_ORDER_STATUS = 'Draft';
export const MAX_NUMBER_OF_PRODUCTS_PER_SUBGROUP = 100;
export const GROUPED_PRODUCTS_TYPES = {
  LAST_USED: 'lastUsed',
  LIMITED: 'limited',
  VIRTUAL_PACKS: 'virtualPacks',
};
export const LOAD_PRODUCTS_LIMIT = 0;
export const DISPLAY_LAST_USED_LIMIT = 5;
